// src/pages/ClientData/utils/buildContent.js

const formatEntries = (obj) => {
  if (!obj) return '';
  return Object.entries(obj)
    .filter(([, value]) => value !== null && value !== undefined && value !== '')
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n');
};

// Compila todos os dados carregados (cliente, processos, movimentos e ficheiros)
// num único texto, usado tanto no "Chat com IA" como em "Salvar em Meus Documentos"
export function buildFullContent({
  clientCode,
  clientData,
  processes,
  processDetails,
  movements,
  movementFiles,
  fileTranscriptions
}) {
  const parts = [];

  if (clientData) {
    parts.push(`=== DADOS DO CLIENTE ${clientCode || ''} ===\n${formatEntries(clientData)}`);
  }

  (processes || []).forEach((processo) => {
    const codigoProcesso = processo['Cod. Processo'];
    const detalhe = processDetails?.[codigoProcesso];
    const dadosProcesso = detalhe || processo;

    parts.push(`=== PROCESSO ${codigoProcesso} ===\n${formatEntries(dadosProcesso)}`);

    const movimentosProcesso = movements?.[codigoProcesso];
    if (movimentosProcesso?.data?.length) {
      const linhas = movimentosProcesso.data.map((movimento) => {
        const referencia = movimento['Referência'];
        const chaveFicheiros = `${codigoProcesso}::${referencia}`;
        const ficheirosMovimento = movementFiles?.[chaveFicheiros];

        let linha = `- [${movimento['Data']}] Ref. ${referencia} - ${movimento['Acto']} | Destino: ${movimento['Destino'] || '-'} | Interveniente: ${movimento['Interveniente'] || '-'} (${movimento['Qualidade'] || '-'})`;

        if (ficheirosMovimento?.Ficheiros?.length) {
          const listaFicheiros = ficheirosMovimento.Ficheiros
            .map((ficheiro) => {
              let linhaFicheiro = `      * ${ficheiro.Nome} (ID ${ficheiro.ID})`;
              if (ficheiro.Caminho) {
                linhaFicheiro += `\n        Caminho: ${ficheiro.Caminho}`;
              }
              const chaveTranscricao = `${chaveFicheiros}::${ficheiro.ID}`;
              const transcricao = fileTranscriptions?.[chaveTranscricao];
              if (transcricao && transcricao.trim()) {
                linhaFicheiro += `\n        Transcrição:\n${transcricao.trim().split('\n').map((l) => `        ${l}`).join('\n')}`;
              }
              return linhaFicheiro;
            })
            .join('\n');
          linha += `\n    Ficheiros:\n${listaFicheiros}`;
        }

        return linha;
      }).join('\n');

      parts.push(`--- MOVIMENTOS DO PROCESSO ${codigoProcesso} ---\n${linhas}`);
    }
  });

  return parts.join('\n\n');
}
